import { useMemo, useState } from 'react'
import { MRT_ColumnDef, MRT_SortingState } from 'material-react-table'
import CustomTable from '../../../../components/common/customTable'
import { useGetPastFormationQuery } from '../../../../hooks/api/formations'
import { FormationType } from '../../../../types/api/formations'
import { DateBody, DateTitle, TitleBody, TypeBody } from './nextFormations'

const PastFormations = () => {
  const [page, setPage] = useState('1')
  const [sorting, setSorting] = useState<MRT_SortingState>([{ id: 'start_date', desc: true }])
  const { data, isFetching } = useGetPastFormationQuery({
    page,
    sort: sorting[0],
  })

  const columns = useMemo<MRT_ColumnDef<FormationType>[]>(
    () => [
      {
        header: 'Date',
        accessorKey: 'start_date',
        Header: DateTitle,
        enableSorting: true,
        Cell: DateBody,
        size: 36,
        minSize: 36,
        maxSize: 36,
      },
      {
        accessorKey: 'type',
        header: 'Type',
        enableSorting: false,
        Cell: TypeBody,
        size: 10,
        minSize: 10,
        maxSize: 10,
      },
      {
        accessorKey: 'title',
        header: 'Formation',
        enableSorting: false,
        Cell: TitleBody,
        size: 54,
        minSize: 54,
        maxSize: 54,
      },
    ],
    [],
  )

  return (
    <CustomTable
      data={data?.data ?? []}
      columns={columns}
      enableSortingRemoval={false}
      enableSorting={true}
      enableMultiSort={false}
      manualSorting
      enableColumnResizing={false}
      onSortingChange={(params) => {
        setPage('1')
        setSorting(params)
      }}
      state={{ sorting, isLoading: isFetching }}
      propsPagination={{
        page: Number(page),
        count:
          data?.metadata?.total && Number(data.metadata.total) > 0
            ? Math.ceil(Number(data.metadata.total) / 10)
            : 1,
        onChange: (e, index) => {
          setPage(index.toString())
        },
      }}
      muiTableBodyRowProps={{ hover: false }}
    />
  )
}

export default PastFormations
